var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-container"},[_c('div',{staticClass:"content"},[_c('z-icon',{staticClass:"result-succ-icon",attrs:{"name":"passed"}}),_c('h3',{staticClass:"result-title"},[_vm._v("提交成功")]),_c('p',{staticClass:"result-desc"},[_vm._v("我们会在24~72小时内审核请耐心等待处理结果")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }